import { render } from "./rect.vue?vue&type=template&id=47fe4a9b&scoped=true"
import script from "./rect.vue?vue&type=script&lang=js"
export * from "./rect.vue?vue&type=script&lang=js"

import "./rect.vue?vue&type=style&index=0&id=47fe4a9b&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fe4a9b"]])

export default __exports__